module.exports = __webpack_public_path__ + "static/media/local-community-occasion-grid-3.07a8684f.jpg";